import { config } from '@app/config';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { getApiV2Client } from '@mi-front/api-v2';

/**
 * Builds a signed OAuth login URL on the unified API host (api-v2), not logger-api.
 */
export function getOauthConnectUrl(platform: SocialPlatform, loginSuffix?: string) {
  const path = `/social-export/v1/auth/${platform.id.toLowerCase()}/login${
    loginSuffix ? `-${loginSuffix}` : ''
  }`;

  return getApiV2Client().generateUrl(`${config.apiV2Root}${path}`, {
    prependBaseURL: false,
    secure: true,
  });
}
